var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.554 419.401H157.64C145.238 419.401 135.186 409.349 135.186 396.947C135.186 384.545 145.238 374.493 157.64 374.493H458.546C470.948 374.493 481 384.545 481 396.947C481 409.349 470.956 419.401 458.554 419.401Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.554 278.458H157.64C145.238 278.458 135.186 268.406 135.186 256.004C135.186 243.602 145.238 233.55 157.64 233.55H458.546C470.948 233.55 481 243.602 481 256.004C481.007 268.406 470.956 278.458 458.554 278.458Z",
    fill: "#5A83FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M458.554 137.514H157.64C145.238 137.514 135.186 127.462 135.186 115.06C135.186 102.658 145.238 92.6062 157.64 92.6062H458.546C470.948 92.6062 481 102.658 481 115.06C481 127.462 470.956 137.514 458.554 137.514Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1557 146.952C77.8102 146.952 91.3114 133.451 91.3114 116.797C91.3114 100.142 77.8102 86.6409 61.1557 86.6409C44.5012 86.6409 31 100.142 31 116.797C31 133.451 44.5012 146.952 61.1557 146.952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1557 286.159C77.8102 286.159 91.3114 272.658 91.3114 256.004C91.3114 239.349 77.8102 225.848 61.1557 225.848C44.5012 225.848 31 239.349 31 256.004C31 272.658 44.5012 286.159 61.1557 286.159Z",
    fill: "#5A83FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1557 425.367C77.8102 425.367 91.3114 411.865 91.3114 395.211C91.3114 378.556 77.8102 365.055 61.1557 365.055C44.5012 365.055 31 378.556 31 395.211C31 411.865 44.5012 425.367 61.1557 425.367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.21ae1f3848987bd3ddf76a60e6aab755.svg";
export { ForwardRef as ReactComponent };